// src/components/ThemeToggle.js
import React from "react";
import { useTheme } from "../ThemeContext";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="theme-toggle-btn"
      title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
    >
      {theme === "dark" ? (
        <span style={{ fontSize: "18px" }}>☀️</span>
      ) : (
        <span style={{ fontSize: "18px" }}>🌙</span>
      )}
    </button>
  );
}
